import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const SportsNavigationWrapper = withConfig(theme => styled('div', { label: 'SportsNavigationWrapper' })`
    background: ${theme.star.unified.sportEventNav.bgColor};
    padding: ${theme.star.padding.xMedium};
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
`);

export const SportsNavigationContent = withConfig(theme => styled('div', { label: 'SportsNavigationContent' })`
    display: flex;
    align-items: center;
    gap: 8px;
    > * {
        color: ${theme.star.unified.sportEventNav.txtColor};
        font-size: ${theme.star.fontSize.small};
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        line-height: 1.3334;
    }
    > * + *::before {
        content: '/';
        color: ${theme.star.unified.sportEventNav.separatorColor};
        margin-right: 8px;
        display: inline-block;
    }
`);

export const SportsNavigationCurrent = styled('span', { label: 'SportsNavigationCurrent' })`
    pointer-events: none;
`;
